<template>
  <div class="order-slider-product">
    <div @click="productPage" :class="{'pointer' : currentPartner && currentPartner.active}">
      <div class="product-image relative">
        <product-image
          class="product-image__content"
          :image="thumbnailObj"
          :alt="product.name | htmlDecode"
          data-testid="productImage"
        />
        <mini-add-to-cart
          v-if="showAddToCart && product.is_available"
          :product="product"
          data-testid="addSingleReorderItem"
          @click.native.stop
        />
      </div>
      <div class="mb5 fs16 start-md pt10" :style="{'color': !product.is_available ? '#999999' : '#111111'}">
        {{ formatQty }}x <strong> {{ allPrice | price }} </strong>
      </div>
      <div class="block-product-description start-md">
        <span class="product-description" :style="{'color': !product.is_available ? '#999999' : '#111111'}"> {{ product.name }} </span>
      </div>
      <div class="product-weight start-md pt10" v-if="product.weight">
        {{ product.weight | toWeight }}
      </div>
      <custom-options-list :selected-options="product.options ? product.options : []" />
    </div>
  </div>
</template>

<script>
import { ProductTile } from '@vue-storefront/core/modules/catalog/components/ProductTile.ts';
import { currentStoreView } from '@vue-storefront/core/lib/multistore';
import { formatProductLink } from '@vue-storefront/core/modules/url/helpers';
import { mapGetters } from 'vuex';

const ProductImage = () => import(/* webpackChunkName: "vsf-product-image" */ 'theme/components/core/ProductImage');
const CustomOptionsList = () => import(/* webpackChunkName: "vsf-custom-options-list" */ 'theme/components/core/blocks/Microcart/Product/CustomOptionsList');
const MiniAddToCart = () => import(/* webpackChunkName: "vsf-mini-add-to-cart" */ 'theme/components/core/MiniAddToCart');

export default {
  name: 'OrderSliderProduct',
  mixins: [ProductTile],
  props: {
    product: {
      type: Object,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    // Only enabled outside the full ReorderList modal (that flow already adds/checks
    // out the whole order at once) - the recent-order-in-cart prompt is the one place
    // adding a single item from a past order makes sense on its own.
    showAddToCart: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ProductImage,
    CustomOptionsList,
    MiniAddToCart
  },
  methods: {
    productPage () {
      if (this.currentPartner && this.currentPartner.active && this.product.is_available) {
        this.$bus.$emit('modal-hide', 'reorder-list' + this.orderId)
        this.$router.push(this.localizedRoute(this.productLink))
      }
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner'
    }),
    allPrice () {
      if (!this.product) return 0;

      let allPrice = this.product.price;
      if (this.product.hasOwnProperty('custom_options') && this.product.custom_options) {
        this.product.custom_options.map(option => {
          if (this.product.newCustomOption && option.is_require) {
            option.values.map(value => {
              allPrice += value.price
            })
          }
        })
      }
      return allPrice
    },
    customOptions () {
      let optionsExists = 'selected_options' in this.product && this.product.selected_options.length > 0
      if (!optionsExists) {
        return []
      }
      let selected = this.product.selected_options
      let options = []
      selected.forEach(selectedOption => {
        let option = this.product.custom_options.find(opt => {
          return opt.values.find(ov => ov.option_type_id === selectedOption.option_type_id)
        })
        options.push(Object.assign({}, { option }, {value: selectedOption}))
      })
      return options
    },
    productLink () {
      if (this.currentPartner && this.product.is_available) {
        return formatProductLink(this.product, currentStoreView().storeCode, this.currentPartner.code, this.currentPartner.location_code)
      }

      return ''
    },
    formatQty () {
      return this.product.is_qty_decimal === 1 ? parseFloat(this.product.qty.toFixed(2)) : this.product.qty
    }
  }
}
</script>

<style scoped lang="scss">
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';

  .order-slider-product{
    width: 100%;
  }
  .product-image{
    width: 100%;
  }
  .block-product-description{
    line-height: 1.5em;
    height: 3em;
    overflow: hidden;
  }
  .product-weight{
    font-size: 14px;
    color: color(gray);
  }
  .product-description{
    font-size: 14px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: 0.09px;
  }
</style>
